import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import LoginPage from "./pages/auth/LoginPage";
import RegisterPage from "./pages/auth/RegisterPage";
import ProtectedRoute from "./components/auth/ProtectedRoute";
import WithSideNavBar from "./components/WithSideNavBar";
import CoachesOverview from "./pages/overview/CoachOverview";
import "./styles/Global.css";
import "./styles/Table.css";
import "./styles/ScheduleRoster.css";
import MemberOverview from "./pages/overview/MemberOverview";
import CourseOverview from "./pages/overview/CourseOverview";
import NewCoach from "./pages/create/NewCoach";
import NewMember from "./pages/create/NewMember";
import NewCourse from "./pages/create/NewCourse";
import { ToastContainer, Zoom } from "react-toastify";
import EditCourse from "./pages/edit/EditCourse";
import EditCoach from "./pages/edit/EditCoach";
import EditMember from "./pages/edit/EditMember";
import ScheduleSettings from "./pages/schedule/ScheduleSettings";
import NewSchedule from "./pages/create/NewSchedule";
import EditSchedule from "./pages/edit/EditSchedule";
import CopySchedule from "./pages/create/CopySchedule";
import TrainingAreas from "./pages/schedule/TrainingAreas";
import NewTrainingArea from "./pages/create/NewTrainingArea";
import EditTrainingArea from "./pages/edit/EditTrainingArea";
import ScheduleRoster from "./pages/schedule/ScheduleRoster";
import Substitutions from "./pages/schedule/Substitutions";
import Attendance from "./pages/schedule/Attendance";
import DayCancellation from "./pages/schedule/DayCancellation";
import MonthSummary from "./pages/overview/MonthSummary";
import Account from "./pages/auth/Account";
import PasswordChange from "./pages/auth/PasswordChange";
import QuickSearch from "./pages/overview/QuickSearch";

function App() {
  return (
    <BrowserRouter>
      <ToastContainer
        position="top-right"
        hideProgressBar={true}
        transition={Zoom}
        limit={1}
        pauseOnFocusLoss={false}
        pauseOnHover={true}
      />
      <Routes>
        <Route path="/" element={<Navigate to="/login" />} />
        <Route path="/signup" element={<RegisterPage />} />
        <Route path="/login" element={<LoginPage />} />

        <Route element={<ProtectedRoute />}>
          <Route element={<WithSideNavBar />}>

            <Route path="/quick-search" element={<QuickSearch />} />

            <Route path="/overview/coaches" element={<CoachesOverview />} />
            <Route path="/overview/coaches/add-new" element={<NewCoach />} />
            <Route path="/overview/coaches/edit/:id" element={<EditCoach />} />
            <Route path="/overview/members" element={<MemberOverview />} />
            <Route path="/overview/members/add-new" element={<NewMember />} />
            <Route path="/overview/members/edit/:id" element={<EditMember />} />
            <Route path="/overview/courses" element={<CourseOverview />} />
            <Route path="/overview/courses/add-new" element={<NewCourse />} />
            <Route path="/overview/courses/edit/:id" element={<EditCourse />} />

            <Route path="/schedule/training-areas" element={<TrainingAreas />} />
            <Route path="/schedule/training-areas/add-new" element={<NewTrainingArea />} />
            <Route path="/schedule/training-areas/edit/:id" element={<EditTrainingArea />} />
            <Route path="/schedule/roster" element={<ScheduleRoster />} />
            <Route path="/schedule/day-cancellation" element={<DayCancellation />} />
            <Route path="/schedule/settings" element={<ScheduleSettings />} />
            <Route path="/schedule/settings/add-new" element={<NewSchedule />} />
            <Route path="/schedule/settings/edit/:id" element={<EditSchedule />} />
            <Route path="/schedule/settings/create-copy" element={<CopySchedule />} />

            <Route path="/schedule/substitutions" element={<Substitutions />} />
            <Route path="/schedule/attendance" element={<Attendance />} />

            <Route path="/month-summary" element={<MonthSummary />} />

            <Route path="/account" element={<Account />} />
            <Route path="/account/change-password" element={<PasswordChange />} />

          </Route>
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
